import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AutocompleteLazy, ListItemText } from '@mic3/platform-ui';
import { bind } from 'app/utils/decorators/decoratorUtils';
import Icon from 'app/components/atoms/Icon/Icon';
import { TypeaheadListItem } from 'app/components/organisms/Form/Typeahead/abstract/TypeaheadListItem';
import Geocode from 'app/utils/maps/geocodeUtils';
import styled from 'styled-components';

const StyledListItemText = styled(ListItemText)`
    span,
    p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

/**
 * Search a location using GraphQL
 */
class GraphQLLocationTypeahead extends PureComponent {
    static propTypes = {
        /* eslint-disable-next-line react/forbid-foreign-prop-types */
        ...AutocompleteLazy.propTypes,
        options: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    @bind
    optionTemplate(props) {
        const { address: adrs, location, display_name } = props;
        const address = adrs && typeof adrs === 'string' ? adrs : display_name; 
        return {
            option: (
                <TypeaheadListItem ContainerComponent="div" dense disableGutters>
                    <Icon name="map-marker" />
                    <StyledListItemText 
                        primary={address} 
                    />
                </TypeaheadListItem>
            ),
            label: address,
            value: { address, location } 
        };
    }

    @bind
    async fetchData(searchText) {
        this.setState({ isLoading: true });
        
        // Don't attempt to search with empty input
        if (!searchText || (typeof searchText === 'string' && searchText.trim() === '')) {
            this.setState({ isLoading: false });
            return [];
        }
        
        try {
            const response = await Geocode.fromAddress(searchText);
            this.setState({ isLoading: false });
            
            if (response?.data?.result?.length) {
                return response.data.result;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
            this.setState({ isLoading: false });
            return [];
        }
    }

    render() {
        const { placeholder, ...rest } = this.props;
        return (
            <AutocompleteLazy
                {...rest}
                VirtualListProps={{
                    itemSize: 60,
                }}
                isLoading={this.state.isLoading}
                optionTemplate={this.optionTemplate}
                placeholder={placeholder || 'Enter a location...'}
                fetchData={this.fetchData}
            />
        );
    }
}

export default GraphQLLocationTypeahead;